// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Layouts
import {Grid, GridRow, GridColumn} from '../layouts/Grid';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import ContentData from '../core/ContentData';
import {DemoLabel, TitleText, TaglineText, HeadingLargeText, HeadingMediumText, HeadingSmallText, BodyText, BodySerifText, BodyMonospaceText, LabelMediumText, LabelSmallText, CaptionText, FootnoteText} from '../core/Type';

export default class TypeSystem extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            typeSystemDemo: {
                paddingTop: CoreMetrics.ElementPadding.XLarge(),
                paddingBottom: CoreMetrics.ElementPadding.XLarge(),
                paddingLeft: 0,
                paddingRight: 0,
            },
            typeStyle: {
                alignItems: "center",
                paddingBottom: CoreMetrics.Grid.VerticalGutter,
            },
            label: {
                display: "block",
                textAlign: "right",
            },
        });
        const typeStyles = {
            "Title": TitleText,
            "Tagline": TaglineText,
            "HeadingLarge": HeadingLargeText,
            "HeadingMedium": HeadingMediumText,
            "HeadingSmall": HeadingSmallText,
            "Body": BodyText,
            "BodySerif": BodySerifText,
            "BodyMonospace": BodyMonospaceText,
            "LabelMedium": LabelMediumText,
            "LabelSmall": LabelSmallText,
            "Caption": CaptionText,
            "Footnote": FootnoteText,
        };
        return (
            <div className={css(styles.typeSystemDemo)}>
                <Grid>
                    {Object.keys(typeStyles).map((name, i) => {
                        const TypeStyleClass = typeStyles[name];
                        return (
                            <GridRow key={name + "Row"} styles={[styles.typeStyle]}>
                                <GridColumn><DemoLabel styles={[styles.label]}>{name}</DemoLabel></GridColumn>
                                <GridColumn variant={GridColumn.Variant.OneHalf}><TypeStyleClass>{ContentData.DummyText[name]}</TypeStyleClass></GridColumn>
                                <GridColumn></GridColumn>
                            </GridRow>
                        );
                    })}
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/demo/TypeSystem.jsx